import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = env.API_BASE;
  // private baseUrl = 'http://192.168.88.12:8000/';
  // private baseUrlT = 'http://192.168.88.12:8002/';
  private baseUrlFile = env.API_FILE;
  private baseUrlTrans = env.API_TRANSACTION;

  // private filterBaseUrl = 'http://192.168.88.251:8000/'

  constructor(private http: HttpClient) { }

  getData(endpoint: string, options: any = {}): Observable<any> {
    const headers = new HttpHeaders({
      'ngrok-skip-browser-warning': 'true'
    });
    // Merge passed-in headers with the new header
    let mergedHeaders = headers;
    if (options.headers) {
      // If additional headers passed in options, append them to our headers
      Object.entries(options.headers).forEach(([key, value]) => {
        mergedHeaders = mergedHeaders.append(key, value as string);
      });
    }
    const mergedOptions = {
      ...options,
      headers: mergedHeaders
    };
    return this.http.get(`${this.baseUrl}${endpoint}`, mergedOptions);
  }

  postData(endpoint: string, data: any, options: any = {}): Observable<any> {
    return this.http.post(`${this.baseUrl}${endpoint}`, data, options);
  }


  putData(endpoint: string, data: any, options: any = {}): Observable<any> {
    return this.http.put(`${this.baseUrl}${endpoint}`, data, options);
  }

  postFileData(file: File, options: any = {}): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.baseUrlFile}`, formData, options);
  }

  deleteData(endpoint: string, options: any = {}): Observable<any> {
    return this.http.delete(`${this.baseUrl}${endpoint}`, options);
  }

  getDataT(endpoint: string, options: any = {}): Observable<any> {
    return this.http.get(`${this.baseUrlTrans}${endpoint}`, options);
  }
} 